import api from "../api";
import { CreateBookingData } from "../validation/booking";

export interface PriceEstimate {
  distance_km: number;
  distance_miles: number;
  estimated_duration_minutes: number;
  base_fare: number;
  per_mile_rate: number;
  distance_charge: number;
  per_minute_rate: number;
  time_charge: number;
  storage_days: number;
  storage_charge: number;
  surge_multiplier: number;
  toll_charge: number;
  ulez_charge: number;
  subtotal: number;
  total: number;
  currency: string;
  quote_id?: string;
  platform_quote_id?: number;
  engine?: string;
  engine_label?: string;
  engine_version?: string;
  job_origin?: string;
  urgency?: string;
  is_operator_exchange?: boolean;
  fair_price_pence?: number;
  customer_total_pence?: number;
  make_offer_allowed?: boolean;
  minimum_offer_pence?: number | null;
  floor_price_pence?: number | null;
  ceiling_price_pence?: number | null;
  expires_at?: string;
}

export interface CheckoutSession {
  checkout_url: string;
  session_id: string;
}

class PricingService {
  async estimatePrice(data: {
    from_latitude: number;
    from_longitude: number;
    to_latitude?: number;
    to_longitude?: number;
    service_type: string;
    vehicle_category?: string;
    is_premium?: boolean;
    storage_days?: number;
    urgency?: string;
  }): Promise<PriceEstimate> {
    const response = await api.post("/pricing/estimate", data);
    return response.data.data;
  }

  async createPlatformQuote(data: {
    from_latitude: number;
    from_longitude: number;
    to_latitude?: number;
    to_longitude?: number;
    service_type: string;
    vehicle_category?: string;
    urgency?: string;
  }): Promise<PriceEstimate> {
    const response = await api.post("/v1/quotes", data);
    return response.data.data;
  }

  async createCheckout(
    data: Partial<CreateBookingData>,
  ): Promise<CheckoutSession> {
    const payload = {
      ...data,
      scheduled_at:
        data.scheduled_at instanceof Date
          ? data.scheduled_at.toISOString()
          : data.scheduled_at,
      vehicle_body_type: data.vehicle_body_type?.toLowerCase(),
    };

    const response = await api.post("/pricing/checkout", payload);
    return response.data.data;
  }
}

export default new PricingService();
